import { createIcon } from '../createIcon';

export const ChevronRightIconConfig = {
  name: 'ChevronRightIcon',
  height: 512,
  width: 320,
  svgPath: 'M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z',
  yOffset: 0,
  xOffset: 0
};

export const ChevronRightIcon = createIcon(ChevronRightIconConfig);

export default ChevronRightIcon;